import React from 'react'
import PropTypes from 'prop-types'
import { PopupTooltip } from '@adc/ui-adc'
import analytics from '../../services/analytics'

const AnalyticsPopupTooltip = ({ elmId = 'undefined_tooltip', ...props }) => (
  <PopupTooltip
    data-elm-id={elmId}
    onOpen={() => analytics.popup(elmId)}
    {...props}
  />
)

AnalyticsPopupTooltip.propTypes = {
  elmId: PropTypes.string,
}

export default AnalyticsPopupTooltip
